module.exports = __webpack_public_path__ + "img/envo-join-logo.94c3e17a.png";